import { render, staticRenderFns } from "./RestablecerContrasena.vue?vue&type=template&id=c65a7130"
import script from "./RestablecerContrasena.vue?vue&type=script&lang=js"
export * from "./RestablecerContrasena.vue?vue&type=script&lang=js"
import style0 from "./RestablecerContrasena.vue?vue&type=style&index=0&id=c65a7130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports